import { ChatRoomMessageChannel } from '@commenda/prisma';
import { fetcher, throwApiError } from '@commenda/utils';

export async function muteChatRoomAgent(
  chatRoomId: string,
  channel: ChatRoomMessageChannel
): Promise<void> {
  const res = await fetcher(`chatRoom/${chatRoomId}/agent/mute`, {
    method: 'POST',
    body: { channel },
  });

  if (!res.ok) {
    await throwApiError(
      res,
      'Commenda Agent could not be muted. Try again in a moment.'
    );
  }
}
